import { FC, useEffect, useRef, useState } from 'react';

type ToggleSwitchProps = {
  toggleText?: string;
  isActive: boolean;
  toggleCallBack?: (isActive: boolean) => void;
  cssClass?: string;
  isDisable?: boolean;
};

const ToggleSwitch: FC<ToggleSwitchProps> = ({
  toggleText,
  isActive,
  toggleCallBack,
  isDisable,
  cssClass = '',
}) => {
  const [isToggleActive, setIsToggleActive] = useState<boolean>(isActive);
  const initialRender = useRef<boolean>(true);

  const onToggleButtonClick = () => {
    setIsToggleActive(!isToggleActive);
  };

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      toggleCallBack && toggleCallBack(isToggleActive);
    }
  }, [isToggleActive]);

  return (
    <div className={`toggle-switch-container ${cssClass}`} data-testid='toggle-switch'>
      <label>{toggleText}</label>
      <label className='toggle-switch'>
        <input
          type='checkbox'
          className='slider-input'
          checked={isToggleActive}
          onChange={onToggleButtonClick}
          data-testid='toggle-slider'
          disabled={isDisable}
        />
        {!isToggleActive ? (
          <span className='slider-disabled round'></span>
        ) : (
          <span className='slider-enabled round'></span>
        )}
      </label>
    </div>
  );
};

export default ToggleSwitch;
